export const PARK_FLOW_URL =
  process.env.REACT_APP_LANDIT_ADMIN_PROJECT_ID === "at-port-admin"
    ? "https://app.park-flow.jp"
    : process.env.REACT_APP_LANDIT_ADMIN_PROJECT_ID === "at-port-admin-stg"
    ? "https://app.stg.park-flow.jp"
    : "https://app.dev.park-flow.jp";
